import * as React from "react";

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  variant?: 'outline';
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className = "", variant = "outline", children, ...props }, ref) => {
    // Styled to match Dub UI inputs
    const baseStyles = "h-10 px-3 py-2 text-sm w-full bg-white border border-neutral-300 rounded-md text-neutral-900 focus:outline-none focus:ring-2 focus:ring-black/5 disabled:opacity-50 disabled:pointer-events-none appearance-none";
    
    // Chevron down icon
    const iconStyles = "bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20stroke%3D%22%236b7280%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20d%3D%22M6%208l4%204%204-4%22%2F%3E%3C%2Fsvg%3E')] bg-[position:right_0.5rem_center] bg-[length:1.25em_1.25em] bg-no-repeat pr-10";

    return (
      <select
        ref={ref}
        className={`${baseStyles} ${iconStyles} ${className}`}
        {...props}
      >
        {children}
      </select>
    );
  }
);

Select.displayName = "Select";


